import * as React from "react";
import { useTableKindId } from "../../newcomponents/table/data/useTableKindId";
import { useTableItemQueryData } from "../../newcomponents/table/data/useTableItemQueryData";
import { Table } from "../../newcomponents/table/table";
import { TableHeaderRefreshButton } from "../../newcomponents/table/components/RefreshButton";
import { NameDescriptionColumn } from "../../newcomponents/table/columns/wellKnown/nameDescriptionColumn";
import { CreatedColumn } from "../../newcomponents/table/columns/wellKnown/createdColumn";
import { LastModifiedColumn } from "../../newcomponents/table/columns/wellKnown/lastModifiedColumn";
import { Quota } from "../../schema/types/quota";
import { quotaHelpers, QuotaTableItem } from "../../mst/kinds/quota.helpers";
import { linksOf } from "../../services/cpln";

export const QuotaList: React.FC = () => {
  const { kind, id } = useTableKindId("quota", "quota-list");
  const qData = useTableItemQueryData<Quota>(kind, {});

  // TODO can move to quota helpers if needed in other pages
  const quotaTableItems: QuotaTableItem[] = qData.visibleItems.map((item) => {
    const selfLink = linksOf(item).self!;
    const idName = item.id + ":s:" + item.name;
    const quota = quotaHelpers.getQuota(item);
    const gvcLink = quotaHelpers.getGvcLink(item);
    const quotaRouteLink = quotaHelpers.getQuotaRouteLink(item);

    return {
      //
      ...item,
      selfLink: selfLink,
      idName: idName,
      quota: quota,
      gvcLink: gvcLink,
      quotaRouteLink: quotaRouteLink,
    };
  });

  return (
    <Table<QuotaTableItem>
      title={"Quotas"}
      data={quotaTableItems}
      tableId={id}
      headerRenderer={(table) => {
        return (
          <>
            <TableHeaderRefreshButton onClick={qData.refetch} />
          </>
        );
      }}
      enableFilter
      isLoading={qData.isLoading}
      onSortChange={qData.setSort}
      onSearchChange={qData.setSearch}
      isLoadingMore={qData.isLoadingMore}
      hasMore={qData.hasMore}
      onLoadMore={qData.fetchNextPage}
      columns={[
        NameDescriptionColumn(undefined, { linkProperty: "idName" }),
        { id: "current", label: "Current", size: 200 },
        { id: "max", label: "Max", size: 200 },
        {
          id: "gvcLink",
          label: "GVC",
          enableResize: true,
        },
        CreatedColumn(),
        LastModifiedColumn(),
      ]}
    />
  );
};
